import React, {useEffect} from "react";
import {connect, useSelector} from "react-redux";


// components
import {showLoader} from "../../../components/loader/loader";


// actions
import {
    ADD_STATE,
    REMOVE_STATE,
    setApp, setUserIsAdmin
} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";


import '../../../assets/css/DragAndDrop.css';
import ProductList from "./_list";



const Product = (props) => {
    const path = '/sales/product';
    const componentState = useSelector(state => getStateByPath(state, path));
    const {loading} = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(path, props.app);

        const userStorage = localStorage.getItem('userData')
        if (userStorage && userStorage !== 'undefined') {
            try {
                const user = JSON.parse(userStorage);
                if (user?.isAdmin)
                    props.setUserIsAdmin(path, true)
                else
                    props.setUserIsAdmin(path, false)

            } catch (e) {
                console.error(e);
            }
        }
    },[]);

    return <>
        { loading && showLoader() }
        { componentState && <ProductList path={path} /> }
    </>
}

const mapStateToProps = _ => ({
});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setApp,
    setUserIsAdmin
})

export default connect(mapStateToProps, mapActionsToProps)(Product);